// Module
var code = "<div v-if=\"addPopupOptions.length > 0\"> <popover @open=\"openAddPopup()\"> <a href=\"#\" class=\"view-mode-btn\" aria-label=\"Open add report popover\"> <icon name=\"add\"></icon> </a> </popover> </div> ";
// Exports
export default code;